function setShipDate () {
    // element to write date to  
    var shipdate = document.getElementById("js-ship-date");
    // Set start date to today - end date in 2 days
    var startDate = new Date();
    var endDate = "", noOfDaysToAdd = 10, count = 0;
  
    // Map numeric month to name  
    var month = new Array();
      month[0] = "January";
      month[1] = "February";
      month[2] = "March";
      month[3] = "April";
      month[4] = "May";
      month[5] = "June";
      month[6] = "July";
      month[7] = "August";
      month[8] = "September";
      month[9] = "October";
      month[10] = "November";
      month[11] = "December";

    while(count < noOfDaysToAdd){
        // add a day to the end date each loop
        endDate = new Date(startDate.setDate(startDate.getDate() + 1));
        // only count when not a weekend
        if(endDate.getDay() != 0 && endDate.getDay() != 6){
           count++;
        }
    }
  
    // update shipdate HTML
    shipdate.innerHTML= month[endDate.getMonth()] + '  ' + endDate.getDate();
}

setShipDate();
